import {
  analytics,
  getScreenTapExportEvent,
} from '~entities/amplitude-analytics';
import type { FindApplicationsRequestParams } from '~entities/application';
import { isReportGenerated } from '~entities/payment/lib/is-report-generated';
import {
  useCheckReportStatusQuery,
  useDownloadReportQuery,
} from '~entities/report';

import { LoadingButton } from '@platform-ui/button';

import { ReactComponent as DownloadIcon } from './download-icon.svg';

import { useGenerateReportMutation } from '../../model/applications-queries';

export const ApplicationsExport = ({
  params,
  disabled,
}: {
  params: FindApplicationsRequestParams;
  disabled?: boolean;
}) => {
  const generateReportMutation = useGenerateReportMutation();
  const checkStatusQuery = useCheckReportStatusQuery(
    generateReportMutation.data?.reportId
  );
  const downloadQuery = useDownloadReportQuery(
    {
      reportData: checkStatusQuery.data,
      screen: 'applications',
    },
    {
      onSuccess() {
        generateReportMutation.reset();
      },
    }
  );

  const handleExportClick = () => {
    generateReportMutation.mutate(params);
    analytics.track(getScreenTapExportEvent('applications'));
  };

  const reportGenerationInProgress =
    generateReportMutation.isSuccess &&
    !isReportGenerated(checkStatusQuery.data);
  const downloadInProgress =
    isReportGenerated(checkStatusQuery.data) && downloadQuery.isLoading;

  const showLoader =
    generateReportMutation.isLoading ||
    reportGenerationInProgress ||
    downloadInProgress;

  return (
    <div className="min-w-[181px]">
      <LoadingButton
        icon={!showLoader && <DownloadIcon />}
        size="m"
        theme="secondary"
        wide
        loading={showLoader}
        disabled={showLoader || disabled}
        onClick={handleExportClick}
      >
        Export to Excel
      </LoadingButton>
    </div>
  );
};
